//import liraries
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";
import { COLORS } from "../../constant";

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      width: 1050,
      height: 500,
      marginTop: 30,
      marginLeft: 30,
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginBottom: 30,
    },
    imageWrapper:{
        flexDirection: "row",
        alignItems: "center",
        marginTop: 5,
      
    },
    cardDetails:{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff",
      borderRadius: 15,
    },
    autoRechargeTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0.24,
      textAlign: "center",
      color: COLORS.black,
      paddingRight: 10,
      paddingTop: 3,
    },
    contentStyle: {
      // paddingTop: 20,
      paddingHorizontal: 30,
    },
    viewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    secondRowStyle:{
      flexDirection:"row",
      justifyContent:"space-between"
    },
    firstRowStyle:{
      flexDirection:'row'
    },
    lowBalanceText: {
      fontSize: 11,
      color: "#FF0000",
      fontWeight: "bold",
      marginLeft: 3,
    },
    backIconViewStyle: {
      flexDirection: "row",
    },
    backIconStyle: {
      width: 19,
      height: 19,
      resizeMode: "center",
    },
    maxProViewStyle:{
      borderColor:COLORS.boderColor,
      borderRadius:12,
      borderWidth:1,
      height:96,
      width:'57%',
      justifyContent:"center",
      paddingHorizontal:8,
      marginHorizontal:10,
      
    },
    KYVBLock:{
      borderColor:COLORS.boderColor,
      borderRadius:12,
      borderWidth:1,
      height:72,
      width:'100%',
      justifyContent:"center",
      paddingHorizontal:15,
      marginTop:10
    },
    updateKYV:{ width: 100, height: 30
    },
    viewVehicleTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0,
      textAlign: "left",
      color: "#999999",
      paddingLeft: 15,
    },
    downloadTextStyle: {
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 12,
      letterSpacing: 0.2,
      textAlign: "center",
      color: "#c2c2c2",
      paddingRight: 20,
      paddingTop: 2,
    },
    detailsViewStyle: {
      flexDirection: "row",
      marginTop: 20,
      alignItems: "center",
    },
    vehicleImageStyle: {
      width: 55,
      height: 50,
      resizeMode: "center",
    },
    vehicleNumTextStyle: {
      fontFamily: "Inter",
      fontSize: 17,
      fontWeight: "600",
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    fastagIdTextStyle: {
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 16,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
      paddingVertical: 5,
    },
    updateRCButtonStyle: {
      width: 86,
      height: 20,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
    },
    updateRCTextStyle: {
      fontFamily: "Inter",
      fontSize: 9,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 11,
      letterSpacing: 0.18,
      textAlign: "center",
      color: "#bd2d37",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    viewStyle1: {
      flexDirection: "row",
      width: '46%',
      height: 96,
      borderRadius: 12,
      backgroundColor: "#ffffff",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      alignItems:"center",
      justifyContent:"center",
      flexWrap:"wrap",
      marginRight:6,
      paddingHorizontal:5
    },
    amountTextStyle: {
      fontFamily: "Inter",
      fontSize: 17,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 20,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    vehicleViewStyle: {
      paddingLeft: 30,
    },

    cardContainer: {
      width: "100%",
      height: "90%",
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginTop: 10,
      alignSelf: "center",
    },
    rowStyle: {
      width: 120,
      minWidth: 120,
      paddingHorizontal: 10,
      marginVertical: 5,
      fontFamily: "Inter",
      fontSize: 9,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 13,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
      paddingVertical: 10,
    },
    headerTextStyle: {
      width: 120,
      height: 30,
      minWidth: 100,
      paddingHorizontal: 10,
      marginVertical: 5,
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    verticalLineStyle: {
      width: 0.5,
      height: "100%",
      backgroundColor: "#a0a0a0",
    },
    headerViewStyle: {
      flexDirection: "row",
      backgroundColor: "#ffffff",
      borderTopRightRadius: 20,
      borderTopLeftRadius: 20,
      borderBottomWidth: 0.5,
      borderColor: "#a0a0a0",
    },
    dataViewStyle: {
      flexDirection: "row",
    },
    topViewStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    tabDetailsCardViewStyle: {
      width: 433,
      height: 145,
      borderRadius: 10,
      shadowColor: "rgba(176, 176, 176, 0.2)",
      shadowOffset: {
        width: 0,
        height: 11,
      },
      shadowRadius: 17,
      shadowOpacity: 1,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ccd0d5",
      flexDirection: "row",
      display: "none",
    },
    rechargeButtonViewStyle: {
      marginTop: 20,
      width: 211,
      height: 36,
    },
    vehicleModalTextStyle: {
      opacity: 0.6,
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 13,
      letterSpacing: 0,
      textAlign: "left",
      color: "#02122c",
    },
    tollImageStyle: {
      width: 27.2,
      height: 21.7,
      resizeMode: "contain",
    },
    tollViewStyle: {
      flexDirection: "row",
      paddingTop: 10,
    },
    mobileViewButtonContainer: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    rechargeTextStyle: {
      fontFamily: "Inter",
      fontSize: 17,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 20,
      letterSpacing: 0.34,
      textAlign: "center",
      color: "#ffffff",
    },
    updateRCButtonStyle1: {
      width: 86,
      height: 20,
      borderRadius: 27,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#bd2d37",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 10,
      marginRight: 10,
    },
    rechargeTranContainer: {
      width: "95%",
      height: 180,
      borderWidth: 1,
      borderColor: "#a0a0a0",
      alignSelf: "center",
      borderRadius: 20,
      alignItems: "center",
      marginTop: 20,
    },
    mpCovered:{
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'space-between',
    },
    mpCoveredText:{
      marginRight:10
    },
    rechargeBtn:{ width: 116, height: 28,marginTop:20 }
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        width: 800,
        borderRadius: 15,
      },
      tabDetailsCardViewStyle: {
        display: "none",
      },
      tollViewStyle: {
        display: "none",
      },
      mobileViewButtonContainer: {
        display: "none",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        height: 649,
        width: "97%",
        borderRadius: 15,
      },
      detailsViewStyle: {
        display: "flex",
        flexDirection:"column"
      },
      secondRowStyle:{
        flex:1,
        width:"100%",
        marginTop:20,
        justifyContent:"space-between"
      },
      rechargeTranContainer:{
        width:"88%"
      },
      fastagIdTextStyle: {
        fontSize: 12,
      },
      viewStyle1: {
        width:"98%",
        paddingTop: 0,
        flexDirection:"column",
      },
      tabDetailsCardViewStyle: {
        paddingHorizontal: 20,
        marginTop: 20,
        display: "flex",
      },
      viewStyle2: { paddingTop: 20 },
      updateRCButtonStyle: {
        marginTop: 20,
      },
      tollViewStyle: {
        display: "none",
      },
      mobileViewButtonContainer: {
        display: "none",
      },
      rechargeButtonViewStyle: {
        width: 120,
        height: 25,
        marginTop: "45%",
        marginRight: "20%",
      },
      maxProViewStyle:{
        flex:1,
        width:"100%"
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: 528,
        height: 649,
        borderRadius: 15,
      },
      detailsViewStyle: {
        display: "none",
      },
      fastagIdTextStyle: {
        fontSize: 12,
      },
      tabDetailsCardViewStyle: {
        paddingHorizontal: 20,
        marginTop: 20,
        display: "flex",
      },

      viewStyle1: {
        paddingTop: 20,
      },
      viewStyle2: { paddingTop: 20 },
      updateRCButtonStyle: {
        marginTop: 20,
      },
      tollViewStyle: {
        display: "none",
      },
      mobileViewButtonContainer: {
        display: "none",
      },

      rechargeButtonViewStyle: {
        width: 120,
        height: 25,
        marginTop: "45%",
        marginRight: "20%",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: "100%",
        height: 758,
        borderRadius: 15,
        marginLeft: 0,
      },
      detailsViewStyle: {
        display: "flex",
        flexDirection:"column"
      },
      secondRowStyle:{
        flexDirection:"column-reverse",
        flex:1,
        width:"100%",
        marginVertical:10,
        justifyContent:"space-between"
      },

      fastagIdTextStyle: {
        fontSize: 10,
      },

      viewStyle1: {
        paddingTop: 10,
        width:"100%",
        height:150
      },
      tabDetailsCardViewStyle: {
        width: 255,
        height: 159,
        flexDirection: "column",
        display: "flex",
        paddingHorizontal: 10,
        marginTop: 20,
      },
      vehicleNumTextStyle: {
        fontSize: 15,
      },
      updateRCButtonStyle: {
        display: "none",
      },
      viewStyle2: {
        flexDirection: "row",
        display: "none",
      },
      rechargeButtonViewStyle: {
        display: "flex",
        marginTop: 10,
        height: 21,
        width: 95,
      },
      mobileViewButtonContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      },
      rechargeTextStyle: {
        fontFamily: "Inter",
        fontSize: 11,
        fontWeight: "bold",
        fontStyle: "normal",
        lineHeight: 13,
        letterSpacing: 0.22,
        textAlign: "center",
        color: "#ffffff",
      },
      rechargeTranContainer: {
        height: 246,
      },
      firstRowStyle:{flexDirection:'column'},
      maxProViewStyle:{
        width:"100%",
        marginVertical:10,
        marginLeft:0
      },
      rechargeBtn:{
        alignSelf:'center',
        marginLeft:20,
        marginTop:3
      },
      contentStyle:{
        paddingHorizontal:10
      }
    },
  }
);

//make this component available to the app
export default useStyles;
